import React, { Component, ErrorInfo, ReactNode } from "react";
import styled from "styled-components";
import { theme } from "../theme";

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: ${theme.colors.darker};
  color: ${theme.colors.text};
  padding: 2rem;
  text-align: center;
`;

const ErrorTitle = styled.h1`
  color: ${theme.colors.error};
  margin-bottom: 1rem;
`;

const ErrorMessage = styled.p`
  color: ${theme.colors.textSecondary};
  margin-bottom: 2rem;
  max-width: 600px;
`;

const RetryButton = styled.button`
  background: ${theme.colors.primary};
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }
`;

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <ErrorContainer>
          <ErrorTitle>Something went wrong</ErrorTitle>
          <ErrorMessage>
            {this.state.error?.message ||
              "An unexpected error occurred. Please try again later."}
          </ErrorMessage>
          <RetryButton onClick={() => window.location.reload()}>
            Reload Page
          </RetryButton>
        </ErrorContainer>
      );
    }

    return this.props.children;
  }
}
